{
  "de": {
    "dressingRoom": {
      "lead": "Stelle Rüstung und Unteranzug zusammen und sieh dir das Outfit in 3D an. Teile es per Link oder melde dich an, um es zu speichern.",
      "slots": {
        "helmet": "Helm",
        "torso": "Torso",
        "arms": "Arme",
        "legs": "Beine",
        "backpack": "Rucksack",
        "undersuit": "Unteranzug",
        "primary": "Primärwaffe",
        "secondary": "Zweitwaffe",
        "sidearm": "Seitenwaffe"
      },
      "size": "S%{size}",
      "choose": "Auswählen…",
      "remove": "Entfernen",
      "openItem": "Gegenstand öffnen",
      "notFound": "Gegenstand nicht gefunden",
      "noHolo": "Noch kein 3D-Modell",
      "empty": "Wähle für einen beliebigen Slot ein Teil, um das Outfit zu sehen.",
      "pose": "Pose",
      "copyLink": "Link kopieren",
      "savedOutfits": "Gespeicherte Outfits",
      "signInToSave": "Melde dich an, um Outfits zu speichern.",
      "outfitName": "Name des Outfits",
      "nameTaken": "Du hast bereits ein Outfit mit diesem Namen.",
      "saveNew": "Als neues Outfit speichern",
      "saveChanges": "Änderungen speichern",
      "noOutfits": "Noch keine gespeicherten Outfits.",
      "pieces": {
        "one": "%{count} Teil",
        "other": "%{count} Teile"
      },
      "confirmDelete": "Das Outfit %{name} löschen?",
      "messages": {
        "saved": "Outfit gespeichert.",
        "saveFailed": "Das Outfit konnte nicht gespeichert werden.",
        "deleteFailed": "Das Outfit konnte nicht gelöscht werden.",
        "linkCopied": "Link kopiert.",
        "copyFailed": "Der Link konnte nicht kopiert werden."
      },
      "groups": {
        "armour": "Rüstung",
        "weapons": "Waffen",
        "gear": "Ausrüstung"
      },
      "hold": "In die Hand nehmen",
      "bodies": {
        "male": "Männlich",
        "female": "Weiblich"
      },
      "positionPending": "Position noch nicht exportiert",
      "fit": {
        "noPort": "%{item} hat hierfür keinen Platz",
        "doesNotFit": "Passt nicht zu %{item}",
        "noWornPiece": "Kein getragenes Teil hat hierfür einen Platz"
      },
      "armorSets": {
        "open": "Rüstungssets",
        "count": {
          "one": "%{count} Set",
          "other": "%{count} Sets"
        }
      },
      "gearHint": "Trage einen Torso, Beine oder einen Unteranzug, um Granaten, Magazine, Pens und Werkzeuge mitzunehmen.",
      "gear": {
        "grenade": "Granate %{number}",
        "magazine": "Magazin %{number}",
        "gadget": "Gadget",
        "medpen": "Medpen %{number}",
        "oxypen": "Oxypen %{number}",
        "utility": "Werkzeug %{number}"
      },
      "saveBlocked": "Behebe die oben markierten Punkte, um dieses Outfit zu speichern.",
      "storage": {
        "title": "Stauraum",
        "space": "%{used} von %{capacity}",
        "add": "Gegenstand hinzufügen",
        "fewer": "Einen weniger",
        "more": "Einen mehr",
        "pickerTitle": "Zu %{piece} hinzufügen",
        "problems": {
          "noStorage": "Hier wird nichts getragen, das diese Gegenstände aufnehmen kann.",
          "overCapacity": "Enthält mehr, als dieses Teil fassen kann.",
          "tooLarge": "Enthält einen Gegenstand, der für dieses Teil zu groß ist.",
          "unmeasured": "Enthält einen Gegenstand ohne gemessene Größe."
        },
        "misfit": {
          "unmeasured": "Keine gemessene Größe",
          "tooLarge": "Zu groß für dieses Teil",
          "noRoom": "Nicht genug Platz übrig"
        }
      },
      "gearNone": "Was du trägst, hat keine Ausrüstungsplätze.",
      "gearColumns": {
        "magazine": "Munition",
        "grenade": "Granaten",
        "medpen": "Medpens",
        "oxypen": "Oxypens"
      }
    }
  }
}
